export default __webpack_public_path__ + "static/media/1.0854ee7a.jpeg";